/* The Supabase client, and the two public values it needs.
 *
 * Both values below are meant to be in client code. The publishable key
 * identifies the project and nothing else — it carries the `anon` role, and
 * what that role may read or write is decided by Row Level Security in
 * `supabase/migrations/`, not by whether someone can see this string. The key
 * that must never appear here is the service-role key, which bypasses RLS
 * entirely. It is not in this repo and has no reason to be.
 *
 * The env overrides exist for the day there is a staging project (#40). If you
 * point this at a different project, the Content-Security-Policy in index.html
 * has to name that origin too, or every request will be blocked — there is a
 * test that keeps the two in step for the default.
 */
import { createClient } from '@supabase/supabase-js';

const env = import.meta.env || {};

export const SUPABASE_URL =
  env.VITE_SUPABASE_URL || 'https://fwcueofvskyypjvftady.supabase.co';

export const SUPABASE_PUBLISHABLE_KEY =
  env.VITE_SUPABASE_PUBLISHABLE_KEY || 'sb_publishable_0oUqEpjeVPiGblH7DT38MA_LkVM1yuD';

let client = null;

/**
 * Created on first use, not on import.
 *
 * The unit suite imports the data and UI modules to render them against a DOM
 * shim, with no browser and no network. Constructing the client at import time
 * would drag storage and a token-refresh timer into that, for tests that never
 * sign anyone in.
 */
export const hasClient = () => !!client;

export function supabase() {
  if (!client) {
    client = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
      auth: {
        persistSession: true,      // survives a reload; localStorage
        autoRefreshToken: true,
        detectSessionInUrl: true,  // completes the OAuth redirect back to us
      },
    });
  }
  return client;
}
